import { For, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import type { CardView } from '../../lib/machine-card';

// Capabilities (#6785; the nine switches are #6766): read-only chips naming the roles
// today's claim can give this machine's `mode` (`capabilityChips`), with the Agents page's
// names. A chip is lit only when the Now zone's role rule names it; on today's data none
// is (the one named role, Gardener, has no chip), and the lit state waits for #6745.

export function CapabilitiesZone(props: { readonly view: CardView }): JSX.Element {
  return (
    <section class="mission-zone" aria-label={t('fleet.machines.card_caps')}>
      <p class="mission-zone__label">
        <span>{t('fleet.machines.card_caps')}</span>
        <Show when={props.view.capabilities.running}>
          {(running) => <span class="mission-zone__side">{running()}</span>}
        </Show>
      </p>
      <ul class="mission-caps">
        <For each={props.view.capabilities.chips}>
          {(chip) => (
            <li class="mission-caps__chip" data-lit={chip.lit ? '' : undefined}>
              <Show when={chip.lit} fallback={chip.name}>
                <span class="mission-caps__dot--lit" aria-hidden="true" />
                <span>{t('fleet.machines.card_cap_lit', { name: chip.name })}</span>
              </Show>
            </li>
          )}
        </For>
      </ul>
    </section>
  );
}
